import { render, staticRenderFns } from "./edit_project.vue?vue&type=template&id=67256134&scoped=true"
import script from "./edit_project.vue?vue&type=script&lang=js"
export * from "./edit_project.vue?vue&type=script&lang=js"
import style0 from "./edit_project.vue?vue&type=style&index=0&id=67256134&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67256134",
  null
  
)

export default component.exports